import React from "react";

export const ColumnsProperty = {
  propertyName: "Columns",
  propertyDisplay: "Columns",
  propertyType: "array",
  propertyCategory: "Layout",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    const ColumnsPropertyInput = React.lazy(() =>
      import("../ColumnsConstructor/ColumnsPropertyInput")
    );

    return (
      <React.Suspense fallback={<div>Loading...</div>}>
        <ColumnsPropertyInput
          handlePropertyChange={handlePropertyChange}
          currentPropertyValues={currentPropertyValues || []}
        />
      </React.Suspense>
    );
  },
};
